import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { JSConn } from "@/utilities/js-conn";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import StatusIndicator from "@/components/StatusIndicator/StatusIndicator.vue";

import {
  filteredWorkOrderTasks,
  localizeTask,
} from "@/components/WorkQueue/shared";
import { ClientAndTasks } from "@/store/modules/workOrderTasks";
import { map as Rmap } from "ramda";
import { NamedRts } from "@/router";
import { ordinalize } from "@/utilities/ordinalize";

export default defineComponent({
  name: "mWorkQueue",
  components: {
    LoadingAnimation,
    StatusIndicator,
  },

  setup(_props, ctx) {
    const $store = ctx.root.$store;
    const dataLoaded = ref(false);
    const loadingMessage = ref(
      "Please wait while the tasks are pulled in from the api...",
    );
    const localTasksGroupedByClient = ref<any[]>([]);
    const filter = ref("");

    const workOrderTasksGroupedByClient = computed(() => {
      return $store.getters.workOrderTasksGroupedByClient as ClientAndTasks[];
    });

    const localWorkOrderTasks = computed(() => {
      return filteredWorkOrderTasks(filter, localTasksGroupedByClient);
    });

    const showTask = (item: { visible: boolean }) => {
      item.visible = !item.visible;
    };

    const workOrderTaskShow = (task: {
      work_order_task_id: string;
      work_order_id: string;
    }) => {
      return {
        name: NamedRts.mWorkOrderTasks,
        params: {
          workOrderId: task.work_order_id,
        },
      };
    };

    const workOrdersIndex = () => {
      return {
        name: NamedRts.mWorkOrders,
      };
    };

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        status: "queued",
      };

      Promise.all([$store.dispatch("needWorkOrderTasks", jsConn)])
        .then(() => {
          localTasksGroupedByClient.value = Rmap(item => {
            return localizeTask(item);
          }, workOrderTasksGroupedByClient.value);
        })
        .finally(() => {
          dataLoaded.value = true;
        });
    });

    return {
      dataLoaded,
      loadingMessage,
      filter,
      localTasksGroupedByClient,
      localWorkOrderTasks,

      showTask,

      workOrderTaskShow,
      workOrdersIndex,

      ordinalize,
    };
  },
});
